import { NotFoundError } from '@fleece/utilities';

/**
 * True once the service no longer has the backtest — it restarted, or dropped it past its
 * retention count. React Query keeps the last data it had, which still says `running`, so
 * without this a lost backtest would read as one still going: polled forever, spinner on,
 * Run disabled.
 */
export function isBacktestLost(error: unknown): boolean {
  return error instanceof NotFoundError;
}
